import { createModel } from '@rematch/core';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { RootModel } from '..';
import type { VendasExternasState } from './types';
import { effects } from './effects';

const initialState: VendasExternasState = {
    atualizarStatus: initReduxFn,
    gerarNotaRetorno: initReduxFn,
    get: initReduxFn,
    getOne: initReduxFn,

    getTable: {
        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },
        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,
    },

    hasUnsavedData: false,
    post: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    totalizadores: initReduxFn,
};

export const VendasExternasModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<VendasExternasState>(),
    state: initialState,
});
